<template>
  <b-modal
    ref="modal"
    title="Preview File"
    modal-class="preview-file-modal"
    body-class="d-flex justify-content-center"
    hide-footer
    @shown="ensureAboveSidebars"
  >
    <b-spinner
      v-show="loading"
      label="Loading..."
    />

    <div v-show="!loading">
      <img
        v-if="previewType === 'image'"
        :src="src"
        class="preview-img"
        @load="onLoad"
      >
      <video
        v-else-if="previewType === 'video'"
        :src="src"
        class="preview-img"
        controls
        muted
        @loadeddata="onLoad"
      />
      <audio
        v-else-if="previewType === 'audio'"
        :src="src"
        controls
        muted
        @loadeddata="onLoad"
      />
    </div>
  </b-modal>
</template>

<script>
import { PREVIEW_FILE_TYPES } from '../../constants/file-image-types'

// Marks BootstrapVue's modal wrapper so the stylesheet below can lift it above
// the layout sidebars (z-index 1040). See ensureAboveSidebars().
const OUTER_CLASS = 'preview-file-modal-outer'

export default {
  name: 'PreviewFileModal',

  data: () => ({
    src: null,
    type: null,
    loading: null,
  }),

  computed: {
    previewType () {
      return PREVIEW_FILE_TYPES[this.type]
    },
  },

  methods: {
    show (src, type) {
      this.loading = true
      this.src = src
      this.type = type
      this.$refs.modal.show()
    },

    onLoad () {
      this.loading = false
    },

    // BootstrapVue portals the dialog into <body> inside a wrapper div that
    // carries `position: absolute; z-index: <base>`. That wrapper IS the
    // stacking context, so lifting it lifts the dialog and its backdrop
    // together, clear of the layout sidebars.
    //
    // Tag the wrapper and let the stylesheet lift it. Two things this must not
    // do, both learned the hard way:
    //
    //   - Never move the dialog or the backdrop out of the wrapper. The
    //     wrapper is what Vue removes on close, so a reparented backdrop is
    //     orphaned in <body>; the next open then adopts that stale node
    //     (querySelectorAll('.modal-backdrop') last match) and closing leaves
    //     a full-screen layer that swallows every click on the page.
    //   - Never set the z-index inline. BootstrapVue binds `style` on that
    //     element, so Vue overwrites it on the next render. It binds no
    //     `class`, which is why a class survives.
    ensureAboveSidebars () {
      this.$nextTick(() => {
        const modal = document.querySelector('.modal.preview-file-modal')
        const wrapper = modal && modal.parentElement

        if (wrapper && wrapper !== document.body) {
          wrapper.classList.add(OUTER_CLASS)
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
/* Reaches the portalled wrapper because BootstrapVue copies the parent's scope
   id onto it (scopedStyleAttrs in its scoped-style mixin), so this compiles to
   `.preview-file-modal-outer[data-v-…]` and matches. `!important` is what beats
   the inline z-index BootstrapVue binds on that same element. */
.preview-file-modal-outer {
  z-index: 1060 !important;
}

::v-deep .modal-dialog {
  min-width: 500px;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 40px);
  width: fit-content;
}
.preview-img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}
</style>
